import React from 'react';
import Lottie from "lottie-react";
import PropTypes from 'prop-types';
import styles from './PlaceOrderLoader.module.css';

const loadingAnimation = require('./imgs/place-order-loader.json');
const completedImages = require('./imgs/completed.png');
const spinnerImage = require('./imgs/spinner.svg');

const PlaceOrderLoader = ({ className, isCompleted }) => {

  if (isCompleted) {
    return (
      <div className={[styles.completed, className].join(' ')}>
        <img src={completedImages} alt='' />
      </div>
    );
  }

  return (
    <div className={[styles.loaderWrapper, className].join(' ')}>
      <div className={styles.loaderContent}>
        
        <Lottie animationData={loadingAnimation} autoPlay loop className={styles.lottie} />

        <p className={styles.textBlock}>
          <span className={styles.title}>Processing Order…</span>
          <span className={styles.subtitle}>Please wait</span>
        </p>

        <img src={spinnerImage} alt='' className={styles.spinner} />
      </div>
    </div>
  );
};

PlaceOrderLoader.propTypes = {
  className: PropTypes.string,
  isCompleted: PropTypes.bool,
};

PlaceOrderLoader.defaultProps = {
  className: '',
  isCompleted: false,
};

export default PlaceOrderLoader;
